import {EnumValidValueItemModel} from '../../enum/enum-valid-value-item.model';
import {FormParagraphDataModel} from './form-paragraph-data.model';
import {FormConfigurationModel} from '../form-configuration.model';
import {XauditModel} from '../../xaudit.model';
import {DataPatientCaseWorkItemFormToothModel} from '../../teeth/data-patient-case-work-item-form-tooth.model';
import {FormVersionConfigurationModel} from '../form-version-configuration.model';

export class PatientCaseWorkItemFormDataModel extends XauditModel {
    CaseWorkItemFormsId: string;
    CaseWorkItemId: string;
    DFormId: string;
    formOrder: number;
    isOpenByDefault: boolean;
    enumFormCompletionStatusID: string;
    cfgDForm: FormConfigurationModel;
    StatusOn: Date;
    StatusBy: string;
    dataFormParagraphs: FormParagraphDataModel[];
    enumFormCompletionStatus: EnumValidValueItemModel;
    Description: string;
    enumFormFilledByID: string;
    enumCustomFormID: string;
    Status: string;

    isRequireSignature: boolean;
    isSubmissionRequired: boolean;
    isSigned: boolean;
    SignedOn: string;
    SignedBy: string;
    Versions: FormVersionConfigurationModel[];
    isToothRequired: boolean;

    dataPatientCaseItemFormTeeth: DataPatientCaseWorkItemFormToothModel[];
    formFilledIcon: string;
    formFilledTooltip: string;
    Completed: boolean;
    RequiredItems: number;
    CompletedItems: number;
}
